var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { Subject } from '@/models/Subject';
import { addClass, getParentWithClass, hasClass, removeClass } from '@/support/Html';
import Student from '@/views/Users/Student/Student.vue';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { StatusSelectColorMap } from '@/support/StatusColorMap';
let SubjectNotes = class SubjectNotes extends Vue {
    // #endregion
    // #region @Refs
    // #endregion
    // #region Class properties
    // #endregion
    // #region Lifecycle Hooks
    mounted() {
        // console.log('*** - this.userSubject:', this.userSubject);
    }
    // #endregion
    // #region Event handlers
    hideFullNotes(event, closeClick = false) {
        const target = event.target;
        let popout;
        if (closeClick) {
            popout = getParentWithClass(target, 'subject-notes__content--popout');
        }
        else {
            popout = target.querySelectorAll('.subject-notes__content--popout')[0];
        }
        if (popout !== null) {
            removeClass(popout, 'show');
        }
    }
    showFullNotes(event) {
        if (event.type === 'click') {
            this.$set(this.userSubject, 'selected', !this.userSubject.selected);
            this.$emit('onSelectSubjectNotes', this.userSubject);
        }
        const target = event.target;
        if (hasClass(target, 'subject-notes__content--popout')) {
            return;
        }
        const td = target;
        const popout = target.querySelectorAll('.subject-notes__content--popout')[0];
        addClass(popout, 'show');
    }
    onSelectSingleItem() {
        this.$emit('onSelectSubjectNotesForSingleItem', this.userSubject);
    }
    clearSelected() {
        this.$set(this.userSubject, 'selected', false);
    }
    // #endregion
    // #region Class methods
    getSubjectGoalIconClass() {
        return `subject-goal__status-icon--${this.userSubject.status}`;
    }
    getLatestNote(notesObject) {
        if (notesObject.length === 0) {
            return '';
        }
        // get latest based on created_at
        const latestNote = notesObject.reduce((latest, current) => {
            return new Date(latest.created_at) > new Date(current.created_at) ? latest : current;
        });
        return latestNote.note;
    }
    getTruncatedNoteText(htmlContent, maxLength) {
        const cleanedContent = htmlContent
            // Replace div and p tags with line breaks
            .replace(/<\/?(div|p)[^>]*>/gi, '\n')
            // Replace br tags with line breaks
            .replace(/<br\s*\/?>/gi, '\n')
            // Replace list items with bullet points
            .replace(/<li[^>]*>/gi, '• ')
            .replace(/<\/li>/gi, '\n')
            // Remove other HTML tags but keep the content
            .replace(/<[^>]*>/g, '')
            // Clean up multiple newlines
            .replace(/\n\s*\n/g, '\n')
            // Trim whitespace
            .trim();
        // If content is short enough, return as is
        if (cleanedContent.length <= maxLength) {
            return cleanedContent;
        }
        // Find the last complete word within the limit
        let truncated = cleanedContent.substring(0, maxLength);
        const lastSpaceIndex = truncated.lastIndexOf(' ');
        const lastNewlineIndex = truncated.lastIndexOf('\n');
        // Use the latest word boundary (space or newline)
        const cutPoint = Math.max(lastSpaceIndex, lastNewlineIndex);
        if (cutPoint > maxLength * 0.7) {
            // Only cut at word boundary if it's not too short
            truncated = truncated.substring(0, cutPoint);
        }
        return truncated + '...';
    }
    // #endregion
    // #region Async methods (api calls only
    // #endregion
    // #region Getters & Setters
    get hasNotes() {
        return (this.userSubject &&
            this.userSubject.notes &&
            this.userSubject.notes.notesObject &&
            this.userSubject.notes.notesObject.length > 0);
    }
    get isSelected() {
        return !!(this.userSubject && this.userSubject.selected);
    }
    get userSubjectSelectColor() {
        if (!this.userSubject || !this.userSubject.status) {
            return 'white';
        }
        return StatusSelectColorMap[this.userSubject.status];
    }
};
__decorate([
    Prop({ required: true }),
    __metadata("design:type", typeof (_a = typeof Subject !== "undefined" && Subject) === "function" ? _a : Object)
], SubjectNotes.prototype, "subject", void 0);
__decorate([
    Prop({ required: true }),
    __metadata("design:type", typeof (_b = typeof Student !== "undefined" && Student) === "function" ? _b : Object)
], SubjectNotes.prototype, "student", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Object)
], SubjectNotes.prototype, "userSubject", void 0);
SubjectNotes = __decorate([
    Component({})
], SubjectNotes);
export default SubjectNotes;
// #endregion
// #region Constants
// #endregion
